<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-8">
        <span class="display-4 col-12">
          {{ $t("COMMON.SALES_DELIVERIES") }}
        </span>
      </div>
    </div>

    <sales-delivery-list-table :filterSalesOrder="salesOrder.id" />
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import SalesDeliveryListTable from "../../SalesDeliveryManagement/partials/SalesDeliveryListTable.vue";

export default {
  name: "sales-order-view-deliveries",

  components: {
    SalesDeliveryListTable,
  },

  mixins: [formMixin],

  props: ["salesOrder"],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
<style scoped>
.delivery-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
